var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 8.96484C14.1504 8.96484 15 9.81445 15 10.8398V13.1836C15 14.2383 14.1504 15.0586 13.125 15.0586H1.875C0.820312 15.0586 0 14.2383 0 13.1836V10.8398C0 9.81445 0.820312 8.96484 1.875 8.96484H5.625V10.3711H1.875C1.61133 10.3711 1.40625 10.6055 1.40625 10.8398V13.1836C1.40625 13.4473 1.61133 13.6523 1.875 13.6523H13.125C13.3594 13.6523 13.5938 13.4473 13.5938 13.1836V10.8398C13.5938 10.6055 13.3594 10.3711 13.125 10.3711H9.375V8.96484H13.125ZM3.98438 5.24414C3.7207 5.53711 3.28125 5.53711 3.01758 5.24414C2.72461 4.98047 2.72461 4.54102 3.01758 4.27734L7.00195 0.292969C7.26562 0 7.70508 0 7.96875 0.292969L11.9531 4.27734C12.2461 4.54102 12.2461 4.98047 11.9531 5.24414C11.8359 5.39062 11.6602 5.44922 11.4844 5.44922C11.2793 5.44922 11.1035 5.39062 10.9863 5.24414L8.20312 2.46094V10.3711C8.20312 10.7812 7.88086 11.0742 7.5 11.0742C7.08984 11.0742 6.79688 10.7812 6.79688 10.3711V2.46094L3.98438 5.24414ZM12.6562 12.0117C12.6562 12.4219 12.334 12.7148 11.9531 12.7148C11.543 12.7148 11.25 12.4219 11.25 12.0117C11.25 11.6309 11.543 11.3086 11.9531 11.3086C12.334 11.3086 12.6562 11.6309 12.6562 12.0117Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.e64dd857.svg";
export { ForwardRef as ReactComponent };